import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { getReactQueryOptions } from '@_/utils-frontend';
import { publicApiQueryClient } from '#src/api.ts';
import { SeoTags } from '#src/components/SeoTags/index.ts';
import { coursePageSearchValidator, CoursesPage } from '#src/pages/CoursesPage/index.ts';

export const Route = createFileRoute('/{-$locale}/courses_/$categorySlug')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const { locale, categorySlug } = params;

    const resp = await queryClient.ensureQueryData(
      getReactQueryOptions(
        publicApiQueryClient.metadata.getCategory,
        { params: { slug: categorySlug } },
        { context: { locale } }
      )
    );

    return {
      category: resp.data
    };
  },
  validateSearch: coursePageSearchValidator
});

function RouteComponent() {
  const { category } = Route.useLoaderData();
  const navigate = Route.useNavigate();
  const searchParams = Route.useSearch();

  const intl = useIntl();

  return (
    <>
      <SeoTags
        title={intl.formatMessage(
          {
            id: 'head.classes-by-category-page',
            defaultMessage: '{category} Classes in Hong Kong'
          },
          {
            category: category.name
          }
        )}
      />

      <CoursesPage
        category={category}
        onUpdateSearchParams={useCallback(search => navigate({ search }), [navigate])}
        searchParams={searchParams}
      />
    </>
  );
}
